import {Outlet, useParams} from "react-router-dom"
import {useContext, useEffect, useRef, useState} from "react";
import AuthContext from "../../context/AuthContext";
import TopNavBar from "../../components/TopNavBar";


export default function ReportsTopNavBar() {

    const {user, logoutUser, authTokens, serverIP} = useContext(AuthContext)

    const projName = "Icecat Taxonomy"

    const topNavItems = [
        {'name': 'Downloads', 'link': ''},
        {'name': 'Full Taxonomy', 'link': 'fulltax/1'},
        // {'name': 'Families', 'link': 'feats/1'},
    ]

    return (
        <>
            <TopNavBar user={user} logoutUser={logoutUser} projName={projName} topNavItems={topNavItems}/>

            <Outlet/>
        </>
    )
}